import { getHostname } from './get-hostname.helper';

export const getDomain = () => {
  const hostname = getHostname();
  let result = '';
  if (hostname) {
    const localhost = 'localhost';
    const separator = '.';
    const start = hostname.indexOf(separator);

    const isIpAddress = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/g.test(
      hostname
    );

    if (isIpAddress) {
      return hostname;
    }

    if (hostname.endsWith(localhost)) {
      const splitted = hostname.split('.');

      return splitted[splitted.length - 1];
    }

    if (start !== -1) {
      const split = hostname.split(separator);

      result = hostname
        .split(separator)
        .slice(split.length - 2)
        .join(separator);
    }
  }

  return result;
};
